import type { ReactNode, JSX} from "react";
import { cn } from "./cn";

export interface ChannelChipProps {
  /** Optional leading icon */
  readonly icon?: ReactNode;
  /** Label text */
  readonly label: string;
  /** Extra className */
  readonly className?: string;
}

/**
 * A small pill-shaped chip with an optional icon and label.
 * Used for channel indicators, tag-like labels, and small badges.
 */
export function ChannelChip({ icon, label, className }: ChannelChipProps): JSX.Element {
  return (
    <span
      className={cn(
        "flex items-center gap-1 text-xs bg-surface-hover rounded-full px-2.5 py-1 text-content",
        className,
      )}
    >
      {icon}
      {label}
    </span>
  );
}
